export const USER_DATA_KEY = 'userData';

export function readStoredUserData() {
  try {
    const raw = sessionStorage.getItem(USER_DATA_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

/**
 * Normalize `initStageReport` response `{ game: { stages } }` into an assignment shape.
 * Stages have been removed — the puzzle is the whole game now, so only `puzzle_id` matters.
 */
export function gameFromInitStageReport(initResult) {
  const g = initResult?.game;
  if (!g || typeof g !== 'object') return null;
  const stages = g.stages ?? g;
  if (!stages || typeof stages !== 'object') return null;
  return {
    id: g.id ?? stages.id ?? null,
    puzzle_id: stages.puzzle_id != null ? Number(stages.puzzle_id) : null,
  };
}

export function applyGameAssignmentToUserData(userData, game) {
  if (!userData || !game) return userData;
  const puzzleId = game.puzzle_id ?? userData.puzzle_id ?? userData.puzzleid ?? null;
  return {
    ...userData,
    puzzle_id: puzzleId,
    puzzleid: puzzleId,
    gameStages: game,
  };
}

/** Reads the puzzle assignment (currently just `puzzle_id`) out of stored user data. */
export function getGameAssignment(source) {
  if (!source || typeof source !== 'object') return null;
  if (source.gameStages && typeof source.gameStages === 'object') return source.gameStages;
  if (source.puzzle_id != null || source.puzzleid != null) {
    return {
      id: source.id ?? null,
      puzzle_id: source.puzzle_id ?? source.puzzleid ?? null,
    };
  }
  return null;
}

/** Merge a fresh `getGameStages` response into session-stored user data. */
export function mergeGameAssignmentIntoUserData({ game, currentStage, nextDay, report }) {
  const stored = readStoredUserData();
  const puzzleId = game?.puzzle_id ?? stored.puzzle_id ?? stored.puzzleid ?? null;
  const merged = {
    ...stored,
    puzzle_id: puzzleId,
    puzzleid: puzzleId,
    gameStages: game ?? stored.gameStages ?? null,
    currentStage: currentStage ?? stored.currentStage ?? null,
    nextDay: nextDay ?? stored.nextDay ?? null,
    ...(report && typeof report === 'object' ? { report } : {}),
  };
  sessionStorage.setItem(USER_DATA_KEY, JSON.stringify(merged));
  return merged;
}
